import { RouteConfig } from "vue-router";

export const administrationRoutes: Array<RouteConfig> = [
  {
    path: `company-details`,
    component: () => import("@/views/administration/account/account-details/index.vue"),
  },
  {
    path: `users`,
    component: () => import("@/views/administration/users/index.vue"),
  },
  {
    path: `organization`,
    component: () => import("@/views/administration/organization/index.vue"),
  },
];
